import { createSlice } from "@reduxjs/toolkit";

const exerciseInitState = {
  isLoading: false,
  exercises: [],
  exercise: {},
};

const exercisesReducerSlice = createSlice({
  name: "exercises",
  initialState: exerciseInitState,
  reducers: {
    changeExerciseLoading: (state, action) => {
      if (state.isLoading !== action.payload) {
        state.isLoading = action.payload;
      }
    },
    setExerciseState: (state, action) => {
      if (state.exercises.length <= 0 || action.payload.refresh) {
        state.exercises = action.payload.exercises || state.exercises;
      }
      state.isLoading = false;
    },
    deleteExerciseState: (state, action) => {
      state.exercises = state.exercises.filter(
        (exercise) => exercise._id !== action.payload
      );
      state.isLoading = false;
    },
    addExerciseState: (state, action) => {
      state.exercises.unshift(action.payload);
      state.isLoading = false;
    },
    updateExerciseState: (state, action) => {
      state.exercises.unshift(action.payload);
      state.isLoading = false;
    },
  },
});

export const {
  changeExerciseLoading,
  setExerciseState,
  addExerciseState,
  updateExerciseState,
  updateBiometricExercise,
  deleteExerciseState,
} = exercisesReducerSlice.actions;

export default exercisesReducerSlice.reducer;
